import React from 'react';
import { AiOutlineSearch } from 'react-icons/ai';
import { Popconfirm, Input, Button, Pagination, Row, Col } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { SERVER_IP } from 'assets/Config';
import TableComponent from 'components/table-component';
import { deleteApi } from 'redux/sagas/deleteApiSaga';
import AddDietPlan from 'pages/diet-plan/add-diet-plan';
import PdfModal from 'components/pdf-modal';
import Loader from 'components/loader';
import { useI18n } from 'hooks/useI18n';

const DietPlanListPresentational = ({
	filteredData,
	column,
	tableLoading,
	rowSelection,
	selectedRowKeys,
	handleAddDietPlan,
	currentPage,
	pageSize,
	initialPageSizeOptions,
	initialPageSize,
	handleTableChange,
	setSearchKey,
	getStartingValue,
	getEndingValue,
	dietPlanAddModal,
	setDietPlanAddModal,
	refreshList,
	editDietPlan,
	handleClose,
	pdfModal,
	handleClosePdfModal,
}) => {
	const dispatch = useDispatch();
	const { t } = useI18n();
	return (
		<>
			<Row>
				<Col span={24} style={{ padding: 0 }}>
					<TableComponent
						loading={tableLoading}
						className="custom-table"
						style={{ width: '100%' }}
						columns={column}
						bordered
						rowKey={(record) => record.id}
						dataSource={filteredData}
						rowSelection={rowSelection}
						title={() => (
							<Row style={{ justifyContent: 'space-between' }}>
								<Col span={8}>
									<Row gutter={[10, 10]}>
										<Col xl={24}>
											<Row gutter={[10, 10]} align="middle">
												<Col>
													<Input
														placeholder={t('common.search')}
														suffix={<AiOutlineSearch />}
														style={{ height: '30px' }}
														onChange={({ target: { value } }) => setSearchKey(value)}
													/>
												</Col>
												{selectedRowKeys?.length === 1 ? (
													<Col>
														<Popconfirm
															title={t('diet_plan.delete_confirm')}
															okText={t('common.delete')}
															cancelText={t('common.no')}
															onConfirm={() => {
															let url = `${SERVER_IP}api/dietPlan/${selectedRowKeys?.[0]}`;
															dispatch(deleteApi('DELETE_DIET_PLAN', url));
															}}>
															<div style={{ textDecoration: 'underline', color: 'red', cursor: 'pointer' }}>{t('common.delete')}</div>
														</Popconfirm>
													</Col>
												) : null}
											</Row>
										</Col>
									</Row>
								</Col>
								<Col>
									<Button
										type="primary"
										icon={<ReloadOutlined />}
										loading={tableLoading}
										onClick={() => refreshList?.()}
										style={{ marginRight: 10 }}
									/>
									<Button
										// icon={<PlusOutlined />}
										type="primary"
										// style={{ height: '30px', width: '100%' }}
										onClick={handleAddDietPlan}>
										{t('diet_plan.actions.create_diet')}
									</Button>
								</Col>
							</Row>
						)}
						pagination={{
							current: currentPage,
							pageSize: pageSize,
							position: ['none', 'none'],
						}}
						footer={() => (
							<Row justify="space-between">
								<Col span={12}>
									{!!filteredData?.length && `Showing ${getStartingValue()} - ${getEndingValue()} of ${filteredData?.length} Data`}
								</Col>
								<Col span={12}>
									<div style={{ textAlign: 'right' }}>
										<Pagination
											pageSizeOptions={initialPageSizeOptions}
											defaultPageSize={initialPageSize}
											showSizeChanger={true}
											total={filteredData?.length}
											onChange={handleTableChange}
											responsive
										/>
									</div>
								</Col>
							</Row>
						)}
					/>
				</Col>
			</Row>
			{ dietPlanAddModal && <AddDietPlan {...{ dietPlanAddModal, setDietPlanAddModal, refreshList, editDietPlan, handleClose }} /> }
			
			<PdfModal
				visible={pdfModal.visible}
				onClose={handleClosePdfModal}
				pdfUrl={pdfModal.url}
				title={pdfModal.title}
				loading={pdfModal.loading}
				error={pdfModal.error}
				width="95%"
				height="85vh"
			/>

			{pdfModal?.loading && <Loader text={t('diet_plan.loader.generating')} />}
		</>
	);
};

export default DietPlanListPresentational;
